"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitDiagnostics = exports.reportDiagnostic = void 0;
/**
 * Helper function to report diagnostics for every diagnosticsMode
 */
function reportDiagnostic(ctx, diagnosticsMode, { message, type }, from) {
    const error = new Error(from ? `[${from}]:\n\n${message}` : message);
    if (type === 'info') {
        ctx.emitWarning(error);
        return;
    }
    if (diagnosticsMode === 'auto') {
        if (type === 'warning') {
            ctx.emitWarning(error);
        }
        else if (type === 'error') {
            ctx.emitError(error);
        }
    }
    else if (diagnosticsMode === 'strict') {
        ctx.emitError(error);
    }
    else if (diagnosticsMode === 'loose') {
        ctx.emitWarning(error);
    }
}
exports.reportDiagnostic = reportDiagnostic;
function emitDiagnostics(ctx, meta, diagnosticsMode, filePath) {
    var _a, _b;
    (_a = meta.diagnostics) === null || _a === void 0 ? void 0 : _a.reports.forEach(handleReport);
    (_b = meta.transformDiagnostics) === null || _b === void 0 ? void 0 : _b.reports.forEach(handleReport);
    function handleReport(diagnostic) {
        reportDiagnostic(ctx, diagnosticsMode, diagnostic, filePath);
    }
}
exports.emitDiagnostics = emitDiagnostics;
//# sourceMappingURL=report-diagnostic.js.map